module.exports = global["jQuery"] = require("-!/Users/henning/Desktop/TMT/typo3conf/ext/yt_tmt/Resources/Private/Sources/node_modules/expose-loader/index.js?$!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ../~/jquery/dist/jquery.js
// module id = 3
// module chunks = 0